import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.LoadableData,
  title: 'Loadable Data',
  category: ComponentCategory.General,
  droppable: true,
};
